export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [100, 125, 150];
